// import React from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";

// const Footer = () => {
//   return (
//     // <div className="mt-4">
//     <footer
//       className="bg-dark text-white text-center  py-1"
//       style={{ position: 'fixed', bottom: "0px", width: "100%" ,height:"60px",padding: '10px'}}
//     >
//       <div className="container">
//         <p>&copy; 2023 Patent Hub. All rights reserved. by- MD MASHOOD ALAM</p>
//       </div>
//     </footer>
//     // </div>
//   );
// };

// export default Footer;

// import React from "react";
// import  './footer.css'
// import "bootstrap/dist/css/bootstrap.min.css";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faFacebookF, faTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons';

// const Footer = () => {
//   return (
//     <footer
//       className="bg-dark text-white text-center py-3 mt-3"
//       style={{ position: 'fixed', bottom: "0", width: "100%", minHeight: "40px", paddingTop: '100px' }}
//     >
//       <div className="container d-flex justify-content-between align-items-center">
//         <p className="m-0">&copy; 2023 Patent Hub. All rights reserved. by MD MASHOOD ALAM</p>
//         <div className="social-media">
//           {/* Social Media Icons */}
//           <a
//             href="https://www.facebook.com/mdmashoodalam2003/"
//             target="_blank"
//             rel="noopener noreferrer"
//             className="text-white mx-2"
//             style={{ fontSize: '1em', textDecoration: 'none' }}
//           >
//             <FontAwesomeIcon icon={faFacebookF} className="social-icon" />
//           </a>
//           <a
//             href="https://twitter.com/MDMASHOODALAM"
//             target="_blank"
//             rel="noopener noreferrer"
//             className="text-white mx-2"
//             style={{ fontSize: '1em', textDecoration: 'none' }}
//           >
//             <FontAwesomeIcon icon={faTwitter} className="social-icon" />
//           </a>
//           <a
//             href="https://www.instagram.com/mashood_ibn_masroor/"
//             target="_blank"
//             rel="noopener noreferrer"
//             className="text-white mx-2"
//             style={{ fontSize: '1em', textDecoration: 'none' }}
//           >
//             <FontAwesomeIcon icon={faInstagram} className="social-icon" />
//           </a>
//           {/* Add more social media icons as needed */}
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;

// import React from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";

// const Footer = () => {
//   return (
//     <div className="mt-4">
//       <footer
//         className="bg-dark text-white text-center  py-1"
//         style={{ position: "fixd", bottom: "0", width: "100%" }}
//       >
//         <div className="container">
//           <p>
//             &copy; 2023 Patent Hub. All rights reserved. 
//           </p>
//         </div>
//       </footer>
//     </div>
//   );
// };

// export default Footer;

import React from "react";
import './footer.css';
import "bootstrap/dist/css/bootstrap.min.css";

const Footer = () => {
  return (
    <footer className="bg-dark text-white text-center py-3">
      <div className="container">
        <p>&copy; 2023 Patent Hub. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;

